<script setup lang="ts">
import { cn } from "@client/lib/utils";
import {
	SplitterGroup,
	type SplitterGroupEmits,
	type SplitterGroupProps,
	useForwardPropsEmits,
} from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<SplitterGroupProps & { class?: HTMLAttributes["class"] }>();
const emits = defineEmits<SplitterGroupEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;
	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<SplitterGroup
		v-bind="forwarded"
		:class="
			cn(
				'tw:flex tw:h-full tw:w-full tw:data-[panel-group-direction=vertical]:flex-col',
				props.class,
			)
		">
		<slot />
	</SplitterGroup>
</template>
